import { useEffect, useState } from "react";
import { BriefcaseBusiness, Menu, Phone, Plus, Send, X } from "lucide-react";
import { Link, NavLink, useLocation } from "react-router-dom";
import useCompanyProfile from "../hooks/useCompanyProfile";
import QuickApplicationDialog from "./QuickApplicationDialog";
import { useSiteContent } from "../content/SiteContentContext";

export default function SiteHeader() {
  const company = useCompanyProfile();
  const { content } = useSiteContent();
  const [quickApplyOpen, setQuickApplyOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    closeMenu();
  }, [pathname]);
  return (
    <header className="site-header" data-testid="site-header">
      <div className="header-inner">
        <Link to="/" className="brand" data-testid="brand-home-link">
          <span className="brand-mark">
            {company.header_logo_url ? <img src={company.header_logo_url} alt={`${company.name} logo`} data-testid="header-logo-image" /> : <BriefcaseBusiness size={22} />}
          </span>
          <span>{company.name === "Apprenticewala" ? <>Apprentice<span>wala</span></> : company.name}</span>
        </Link>
        <nav className="desktop-nav" data-testid="desktop-navigation">
          <NavLink to="/" data-testid="nav-jobs-link">{content.header_jobs_label}</NavLink>
          <NavLink to="/blog" data-testid="nav-blog-link">{content.header_blog_label}</NavLink>
          <NavLink to="/gallery" data-testid="nav-gallery-link">{content.header_gallery_label}</NavLink>
          <NavLink to="/employer/login" data-testid="nav-employer-login-link">Employer Login</NavLink>
        </nav>
        <div className="header-actions">
          {company.phone ? <a href={`tel:${company.phone}`} className="call-now-button" aria-label={content.header_call_label} data-testid="header-call-now-button"><Phone size={16} /> {content.header_call_label}</a> : <button className="call-now-button" disabled aria-label={content.header_call_label} data-testid="header-call-now-button"><Phone size={16} /> {content.header_call_label}</button>}
          <button type="button" className="apply-header-button" onClick={() => setQuickApplyOpen(true)} aria-label={content.header_apply_label} data-testid="header-apply-now-button"><Send size={16} /> {content.header_apply_label}</button>
          <Link to="/employers" className="post-job-button" data-testid="header-post-job-link">
            <Plus size={17} /> {content.header_post_label}
          </Link>
          <button className="mobile-menu-toggle" type="button" onClick={() => setMenuOpen(!menuOpen)} aria-label={menuOpen ? "Close menu" : "Open menu"} aria-expanded={menuOpen} data-testid="mobile-menu-button">
            {menuOpen ? <X size={21} /> : <Menu size={21} />}
          </button>
        </div>
        <nav className={menuOpen ? "mobile-nav open" : "mobile-nav"} data-testid="mobile-navigation">
          <NavLink to="/" onClick={closeMenu} data-testid="mobile-nav-jobs-link">{content.header_jobs_label}</NavLink>
          <NavLink to="/blog" onClick={closeMenu} data-testid="mobile-nav-blog-link">{content.header_blog_label}</NavLink>
          <NavLink to="/gallery" onClick={closeMenu} data-testid="mobile-nav-gallery-link">{content.header_gallery_label}</NavLink>
          <NavLink to="/employer/login" onClick={closeMenu} data-testid="mobile-nav-employer-login-link">Employer Login</NavLink>
        </nav>
      </div>
      {quickApplyOpen && <QuickApplicationDialog onClose={() => setQuickApplyOpen(false)} />}
    </header>
  );
}